import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { CONTACT } from "../mock";
import SocialLinks from "./SocialLinks";

const Footer = () => {
  return (
    <footer className="bg-[#0E1613] text-neutral-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/images/logo.png" alt="Alameda Brazilian Jiu-Jitsu Academy" className="h-10 w-10 rounded-full object-cover" />
              <span className="font-display font-extrabold text-white tracking-tight">ALAMEDA BJJ</span>
            </div>
            <p className="text-sm text-neutral-400 leading-relaxed">
              Authentic Brazilian Jiu-Jitsu & Self-Defense for toddlers, kids, teens and adults. Home of World Champion Professor Sergio Silva.
            </p>
            <div className="mt-5">
              <SocialLinks />
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-br-green transition-colors">About</Link></li>
              <li><Link to="/programs" className="hover:text-br-green transition-colors">Programs</Link></li>
              <li><Link to="/after-school" className="hover:text-br-green transition-colors">After School</Link></li>
              <li><Link to="/schedule" className="hover:text-br-green transition-colors">Schedule</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Get Started</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/tryout" className="hover:text-br-green transition-colors font-semibold text-br-yellow">$99 New Student Tryout</Link></li>
              <li><Link to="/trial" className="hover:text-br-green transition-colors">Free First Class</Link></li>
              <li><Link to="/es" className="hover:text-br-green transition-colors" data-testid="footer-es-link">Español</Link></li>
              <li><Link to="/pt" className="hover:text-br-green transition-colors" data-testid="footer-pt-link">Português</Link></li>
              <li><Link to="/pricing" className="hover:text-br-green transition-colors">Web Pricing</Link></li>
              <li><Link to="/newsletter" className="hover:text-br-green transition-colors">Newsletter & Free eBook</Link></li>
              <li><Link to="/contact" className="hover:text-br-green transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm tracking-wide">Visit Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><MapPin size={17} className="text-br-green shrink-0 mt-0.5" /><span>{CONTACT.addressShort}<br /><span className="text-neutral-500 text-xs">{CONTACT.addressNote}</span></span></li>
              <li className="flex gap-3"><Phone size={17} className="text-br-green shrink-0 mt-0.5" /><a href={CONTACT.phoneHref} className="hover:text-br-green">{CONTACT.phone}</a></li>
              <li className="flex gap-3"><Mail size={17} className="text-br-green shrink-0 mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-br-green">{CONTACT.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6">
          <p className="text-xs text-neutral-500 leading-relaxed mb-4">
            Brazilian Jiu-Jitsu, Submission Wrestling, Mixed Martial Arts &amp; Self-Defense for kids, teens and adults —
            proudly serving Alameda, Oakland, San Leandro, Berkeley, Emeryville, Hayward and the greater East Bay / Bay Area.
          </p>
          <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-500">
            <span>&copy; {new Date().getFullYear()} Alameda Brazilian Jiu-Jitsu &amp; Self-Defense Academy. All rights reserved.</span>
            <span>Team Silva Jiu-Jitsu</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
